import * as t from 'io-ts';

import {colorForInteger} from '../../../libs/shared/ui/src/styles/colorHelpers';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {FrameTypesEnum, makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime type.
 */

const RPluginDirty = t.readonly(
  t.type({
    id: t.Integer,
    frameType: t.literal(FrameTypesEnum.PLUGIN),
    frameId: t.string,
    authSecret: t.string,
    domain: t.string,
    endpoint: t.string,
    name: t.string,
    color: makeEnumRuntimeType(PaletteColorsEnum),
    ownerId: t.union([t.undefined, t.Integer]),
    updatedAt: t.Integer,
  }),
  'plugin',
);

/*
 * Type.
 */

export interface PluginModel extends t.TypeOf<typeof RPluginDirty> {}
export const RPlugin = t.clean<PluginModel>(RPluginDirty as any);

/*
 * IO methods.
 */

export function parsePlugin(src: any): PluginModel {
  return {
    id: src.id,
    frameType: FrameTypesEnum.PLUGIN,
    frameId: `plugin:${src.id}`,
    authSecret: src.auth_secret,
    domain: src.domain,
    endpoint: src.endpoint,
    name: src.name,
    color: colorForInteger(src.id),
    ownerId: (src.dev && src.owner_id) || undefined,
    updatedAt: src.updated_at || 0,
  };
}

/*
 * API type.
 */

export const ApiPlugin = makeApiType('customPlugin', RPlugin, parsePlugin);
